import styled from "styled-components";

export const SuggestedVideosContainer = styled.div`
	padding-bottom: 200px;
`;

export const ButtonContainer = styled.div`
	height: 50px;
	padding: 10px;
	display: flex;
	justify-content: center;
	gap: 20px;
`;
